import React from 'react';
import { Form, Input, message } from 'antd';
import { User, Mail, Save, Shield, Key } from 'lucide-react';
import clsx from 'clsx';

export default function Settings() {
  const [form] = Form.useForm();

  const handleUpdateProfile = async (values) => {
    // Implement API call here
    message.success('Профиль обновлен');
  };

  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-white to-slate-400 mb-8">
        Настройки аккаунта
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Sidebar Navigation (Visual only for now) */}
        <div className="space-y-2">
          <button className="w-full text-left px-4 py-3 rounded-xl bg-white/10 text-white font-medium flex items-center gap-3 border border-primary/20">
            <User size={18} />
            Профиль
          </button>
          <button className="w-full text-left px-4 py-3 rounded-xl hover:bg-white/5 text-slate-400 hover:text-white font-medium flex items-center gap-3 transition-colors">
            <Shield size={18} />
            Безопасность
          </button>
          <button className="w-full text-left px-4 py-3 rounded-xl hover:bg-white/5 text-slate-400 hover:text-white font-medium flex items-center gap-3 transition-colors">
            <Key size={18} />
            API Ключи
          </button>
        </div>

        {/* Content Area */}
        <div className="md:col-span-2">
          <div className="glass-panel p-8">
            <div className="flex items-center gap-4 mb-8">
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-primary to-secondary flex items-center justify-center text-3xl font-bold text-white shadow-neon">
                JD
              </div>
              <div>
                <h2 className="text-xl font-bold text-white">John Doe</h2>
                <p className="text-slate-400">Administrator</p>
              </div>
            </div>

            <Form
              form={form}
              layout="vertical"
              onFinish={handleUpdateProfile}
              className="space-y-6"
              initialValues={{
                email: 'john@example.com',
                username: 'johndoe'
              }}
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <Form.Item
                  label={<span className="text-slate-300">Email</span>}
                  name="email"
                  rules={[{ type: 'email', required: true }]}
                >
                  <Input 
                    className="input-field" 
                    prefix={<Mail size={16} className="text-slate-500 mr-2" />} 
                  />
                </Form.Item>
                <Form.Item
                  label={<span className="text-slate-300">Имя пользователя</span>}
                  name="username"
                  rules={[{ required: true }]}
                >
                  <Input 
                    className="input-field" 
                    prefix={<User size={16} className="text-slate-500 mr-2" />} 
                  />
                </Form.Item>
              </div>

              <div className="pt-6 border-t border-white/5">
                <h3 className="text-lg font-medium text-white mb-4">Смена пароля</h3>
                <div className="space-y-4">
                  <Form.Item
                    label={<span className="text-slate-300">Текущий пароль</span>}
                    name="currentPassword"
                  >
                    <Input.Password className="input-field" placeholder="••••••••" />
                  </Form.Item>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <Form.Item
                      label={<span className="text-slate-300">Новый пароль</span>}
                      name="newPassword"
                    >
                      <Input.Password className="input-field" placeholder="••••••••" />
                    </Form.Item>
                    <Form.Item
                      label={<span className="text-slate-300">Подтвердите пароль</span>}
                      name="confirmPassword"
                    >
                      <Input.Password className="input-field" placeholder="••••••••" />
                    </Form.Item>
                  </div>
                </div>
              </div>

              <div className="flex justify-end pt-4">
                <button 
                  type="submit"
                  className="btn-primary flex items-center gap-2"
                >
                  <Save size={18} />
                  Сохранить изменения
                </button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
